import { render, staticRenderFns } from "./settings-html-defaults.vue?vue&type=template&id=71e54b8d&"
import script from "./settings-html-defaults.vue?vue&type=script&lang=js&"
export * from "./settings-html-defaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports